import React from 'react';

import { Text, Button } from '@soluto-design/react';

import cls from '@soluto-design/styles/cls';

export interface StepsProps {
    text: string;
    onClick?: () => void;
    total: number;
    current?: number;
    className?: string;
}

const Steps = ({
    text,
    onClick = () => {},
    total,
    current = 0,
    className,
}: StepsProps) => {
    if (current === 0) {
        return null;
    }

    return (
        <div className={cls('flex items-center', className)}>
            <Button
                component="button"
                variant="secondary"
                size="large"
                onClick={(ev) => {
                    ev.preventDefault();
                    if (typeof onClick === 'function') {
                        onClick();
                    }
                }}
                leftIcon="arrow-direction--type-left">
                <Text component="span" className={cls('ml-1 small')}>
                    {`${text} ${current}/${total}`}
                </Text>
            </Button>
        </div>
    );
};

export default Steps;
